export default {
  props: {
    canScud: {
      type: Boolean,
      default: false
    }
  }
}
